import API from "./GlobalAPI";
import { getUserById } from "./UserAPI";

export async function getAllFoods() {
  try {
    const res: any = await API.getMethod("foods");
    return res.data;
  } catch (err) {
    console.log(err);
  }
}

export async function getFoodById(id: string) {
  try {
    const res: any = await API.getMethod(`foods/${id}`);

    let flag = 0;
    res.data.reviews.forEach(async (review: any, idx: number, array: any) => {
      const user = await getUserById(review.user);
      res.data.reviews.user_detail = user.data;
      if (idx === array.length - 1) {
        flag = 1;
      }
    });

    if (flag === 1) {
      return res.data;
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getOnlyFoodById(id: string) {
  try {
    const res: any = await API.getMethod(`foods/${id}`);

    return res.data;
  } catch (err) {}
}

export async function getFoodBySlug(slug: string) {
  try {
    const res: any = await API.getMethod(`foods?slug=${slug}`);

    await Promise.all(
      res.data[0].reviews.map(async (review: any) => {
        const user = await getUserById(review.user);
        review.user_detail = {
          full_name: user.full_name,
          picture: user.picture,
        };
      })
    );

    return res.data[0];
  } catch (err) {
    console.log(err);
  }
}

export async function getFoodsByCategory(categoryId: string) {
  try {
    const res: any = await API.getMethod("categories");

    return res.data.foods;
  } catch (err) {
    console.log(err);
  }
}

export async function getFoodByCategoryId(categoryId: string) {
  try {
    const res: any = await API.getMethod(`foods?category=${categoryId}`);

    return res.data;
  } catch (err) {
    console.log(err);
  }
}
